import { amsAxios } from 'utils/axiosHelper';

export const authAPI = {
  fetchUser: () => {
    return amsAxios.get('/auth/user');
  },
  fetchAuthStatus: () => {
    return amsAxios.get('/auth/status');
  },
  updateUserPermissions: (user, payload) => {
    let { sub } = user;
    return amsAxios.post(`/user/${sub}/permissions`, payload);
  },
  getUserPermissions: (user) => {
    return amsAxios.get(`/user/${user.sub}/permissions`);
  },
  createUserPermissions: async (user) => {
    await amsAxios.get(`/user/${user.sub}/permissions/set`);

    return authAPI.getUserPermissions(user);
  },
  setUserBookmarks: (user, bookmarks) => {
    let { sub } = user;
    return amsAxios.post(`/bookmarks/${sub}/set`, bookmarks);
  },
  getUserAccess: () => {
    return amsAxios.get('/user/access-controls');
  },
};
